import { createI18n } from 'vue-i18n';
import Cookies from 'quasar/src/plugins/Cookies.js';import Quasar from 'quasar/src/vue-plugin.js';;
import messages from '@/i18n';
import type { App } from 'vue';
import { moment } from '@/boot/moment';

export type MessageLanguages = keyof typeof messages
const SUPPORTED = ['ru', 'mn', 'es'] as const;
type Locale = typeof SUPPORTED[number]

const Q_PACKS: Record<Locale, () => Promise<any>> = {
  ru: () => import('quasar/lang/ru'),
  es: () => import('quasar/lang/es'),
  mn: () => import('@/quasar-lang/mn'), // ваш локальный пакет
};

// поменяйте при желании дефолт
const DEFAULT_LOCALE: Locale = 'ru';

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: (Cookies.has('locale') ? (Cookies.get('locale') as Locale) : DEFAULT_LOCALE),
  fallbackLocale: DEFAULT_LOCALE,
  messages,
});

/** Безопасно грузит язык Quasar по коду или ставит en-US как запасной */
async function applyQuasarLang(l: Locale) {
  try {
    const { default: pack } = await Q_PACKS[l](); // <-- pack: QuasarLanguage
    Quasar.lang.set(pack);
  } catch {
    const { default: en } = await import('quasar/lang/en-US');
    Quasar.lang.set(en);
  }
}

/** Единая точка смены языка в рантайме */
export async function setLocale(l: Locale) {
  if (!SUPPORTED.includes(l)) return;
  i18n.global.locale.value = l;
  Cookies.set('locale', l, { expires: 365 });

  await applyQuasarLang(l);

  // синхронизируем moment (неделя с понедельника)
  moment.updateLocale(l, { week: { dow: 1 } });
  moment.locale(l);
}

export function initI18n(app: App) {
  app.use(i18n);
  // стартовый язык
  applyQuasarLang(i18n.global.locale.value as Locale);
  // и сразу подстроим moment на старте
  const l = (i18n.global.locale.value as Locale);
  moment.updateLocale(l, { week: { dow: 1 } });
  moment.locale(l);
}

export const { t } = i18n.global;
